import React from 'react';
import get from 'lodash/get';
import { GenericCheckbox } from 'web-ui-components/lib/data/capture';
import { GenericFieldWrapper } from 'web-ui-components/lib/layout/fieldWrappers';
import { Field } from 'react-final-form';
import { Content } from '../../../infrastructure/content';
import { isCheck } from '../../../utils/validation';
import PaymentTypeCashDeposit from './PaymentTypeCashDeposit';

const PaymentType = ({ values }) => {
  const selectedID = values.paymentOfType !== null ? get(values, 'paymentOfType', []) : [];
  return (
    <Content>
      {({
        accountDetailsTypeOfPaymentTitle = '',
        accountDetailsTypeOfPayementCheckBoxCash = '',
        accountDetailsTypeOfPayementCheckBoxCheck = '',
        accountDetailsTypeOfPayementCheckBoxIB = '',
        accountDetailPaymentOfTypeError = '',
        accountDetailsTypeOfPaymentTitleHelpText = '',
        accountDetailsTypeOfPayementCheckBoxIBValue
      }) => (
        <Field
          name="paymentOfType"
          subscription={{ touched: true, error: true }}
          validate={isCheck}
        >
          {({ meta: { touched, error }, input }) => (
            <GenericFieldWrapper
              inputId="paymentOfType"
              title={accountDetailsTypeOfPaymentTitle}
              validationMessage={touched && !!error ? accountDetailPaymentOfTypeError : ''}
              description={accountDetailsTypeOfPaymentTitleHelpText}
            >
              <GenericCheckbox.StackedSet
                {...input}
                items={[
                  {
                    id: accountDetailsTypeOfPayementCheckBoxCash,
                    labelText: accountDetailsTypeOfPayementCheckBoxCash
                  }
                ]}
                groupName="paymentOfType"
                onChange={selectedIds => {
                  input.onChange(selectedIds);
                }}
                selectedIds={selectedID}
              />
              {values && values.paymentOfType && values.paymentOfType.indexOf('Cash') > -1 && (
                <PaymentTypeCashDeposit />
              )}
              <GenericCheckbox.StackedSet
                {...input}
                items={[
                  {
                    id: accountDetailsTypeOfPayementCheckBoxCheck,
                    labelText: accountDetailsTypeOfPayementCheckBoxCheck
                  },
                  {
                    id: accountDetailsTypeOfPayementCheckBoxIBValue,
                    labelText: accountDetailsTypeOfPayementCheckBoxIB
                  }
                ]}
                groupName="paymentOfType"
                onChange={selectedIds => {
                  input.onChange(selectedIds);
                }}
                selectedIds={selectedID}
              />
            </GenericFieldWrapper>
          )}
        </Field>
      )}
    </Content>
  );
};

export default PaymentType;
